// AUTO-GENERATED (gen_import_i18n.py). 20 languages translated from FR via LLM.
export const IMPORT_GEN = {
 "it": {
  "ui": {
   "title": "Assistente di importazione",
   "subtitle": "Importa i tuoi animali, clienti, prodotti e scorte da un file CSV o Excel.",
   "columns": "{n} colonne",
   "changeType": "Cambia tipo",
   "expectedColumns": "Colonne attese:",
   "downloadTemplate": "Scarica il modello",
   "dropzone": "Clicca per scegliere un file CSV o Excel",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Analisi del file…",
   "validRows": "{n} riga/e valida/e",
   "errorRows": "{n} riga/e con errori",
   "recognizedColumns": "Colonne riconosciute:",
   "previewNote": "Anteprima delle prime {n} righe.",
   "lineLabel": "Riga",
   "importBtn": "Importa {n} riga/e",
   "cancel": "Annulla",
   "successMsg": "{n} elemento/i importato/i con successo 🎉",
   "skipped": "{n} riga/e ignorata/e per errori.",
   "importAnother": "Importa un altro file",
   "imported": "{n} elemento/i importato/i"
  },
  "res": {
   "customers": "Clienti",
   "products": "Prodotti",
   "inventory-items": "Scorte",
   "animal-batches": "Allevamento / Animali"
  }
 },
 "es": {
  "ui": {
   "title": "Asistente de importación",
   "subtitle": "Importe sus animales, clientes, productos y existencias desde un archivo CSV o Excel.",
   "columns": "{n} columnas",
   "changeType": "Cambiar tipo",
   "expectedColumns": "Columnas esperadas:",
   "downloadTemplate": "Descargar plantilla",
   "dropzone": "Haga clic para elegir un archivo CSV o Excel",
   "fileHint": ".csv, .xlsx — máx 5 Mo",
   "analyzing": "Analizando el archivo…",
   "validRows": "{n} fila(s) válida(s)",
   "errorRows": "{n} fila(s) con error",
   "recognizedColumns": "Columnas reconocidas:",
   "previewNote": "Vista previa de las primeras {n} filas.",
   "lineLabel": "Línea",
   "importBtn": "Importar {n} fila(s)",
   "cancel": "Cancelar",
   "successMsg": "{n} elemento(s) importado(s) correctamente 🎉",
   "skipped": "{n} fila(s) omitida(s) por errores.",
   "importAnother": "Importar otro archivo",
   "imported": "{n} elemento(s) importado(s)"
  },
  "res": {
   "customers": "Clientes",
   "products": "Productos",
   "inventory-items": "Existencias",
   "animal-batches": "Ganadería / Animales"
  }
 },
 "de": {
  "ui": {
   "title": "Import-Assistent",
   "subtitle": "Importieren Sie Ihre Tiere, Kunden, Produkte und Bestände aus einer CSV- oder Excel-Datei.",
   "columns": "{n} Spalten",
   "changeType": "Typ ändern",
   "expectedColumns": "Erwartete Spalten:",
   "downloadTemplate": "Vorlage herunterladen",
   "dropzone": "Klicken Sie, um eine CSV- oder Excel-Datei auszuwählen",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Datei wird analysiert…",
   "validRows": "{n} gültige Zeile(n)",
   "errorRows": "{n} fehlerhafte Zeile(n)",
   "recognizedColumns": "Erkannte Spalten:",
   "previewNote": "Vorschau der ersten {n} Zeilen.",
   "lineLabel": "Zeile",
   "importBtn": "{n} Zeile(n) importieren",
   "cancel": "Abbrechen",
   "successMsg": "{n} Element(e) erfolgreich importiert 🎉",
   "skipped": "{n} Zeile(n) wegen Fehlern übersprungen.",
   "importAnother": "Eine weitere Datei importieren",
   "imported": "{n} Element(e) importiert"
  },
  "res": {
   "customers": "Kunden",
   "products": "Produkte",
   "inventory-items": "Bestand",
   "animal-batches": "Tierhaltung / Tiere"
  }
 },
 "sv": {
  "ui": {
   "title": "Importassistent",
   "subtitle": "Importera dina djur, kunder, produkter och lager från en CSV- eller Excel-fil.",
   "columns": "{n} kolumner",
   "changeType": "Byt typ",
   "expectedColumns": "Förväntade kolumner:",
   "downloadTemplate": "Ladda ner mall",
   "dropzone": "Klicka för att välja en CSV- eller Excel-fil",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Analyserar filen…",
   "validRows": "{n} giltig(a) rad(er)",
   "errorRows": "{n} rad(er) med fel",
   "recognizedColumns": "Identifierade kolumner:",
   "previewNote": "Förhandsgranskning av de {n} första raderna.",
   "lineLabel": "Rad",
   "importBtn": "Importera {n} rad(er)",
   "cancel": "Avbryt",
   "successMsg": "{n} element importerade 🎉",
   "skipped": "{n} rad(er) ignorerade på grund av fel.",
   "importAnother": "Importera en annan fil",
   "imported": "{n} element importerade"
  },
  "res": {
   "customers": "Kunder",
   "products": "Produkter",
   "inventory-items": "Lager",
   "animal-batches": "Djurhållning / Djur"
  }
 },
 "nl": {
  "ui": {
   "title": "Importassistent",
   "subtitle": "Importeer uw dieren, klanten, producten en voorraden vanuit een CSV- of Excel-bestand.",
   "columns": "{n} kolommen",
   "changeType": "Type wijzigen",
   "expectedColumns": "Verwachte kolommen:",
   "downloadTemplate": "Sjabloon downloaden",
   "dropzone": "Klik om een CSV- of Excel-bestand te kiezen",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Bestand analyseren…",
   "validRows": "{n} geldige rij(en)",
   "errorRows": "{n} rij(en) met fouten",
   "recognizedColumns": "Herkende kolommen:",
   "previewNote": "Voorvertoning van de eerste {n} rijen.",
   "lineLabel": "Rij",
   "importBtn": "{n} rij(en) importeren",
   "cancel": "Annuleren",
   "successMsg": "{n} item(s) succesvol geïmporteerd 🎉",
   "skipped": "{n} rij(en) overgeslagen wegens fouten.",
   "importAnother": "Een ander bestand importeren",
   "imported": "{n} item(s) geïmporteerd"
  },
  "res": {
   "customers": "Klanten",
   "products": "Producten",
   "inventory-items": "Voorraad",
   "animal-batches": "Veeteelt / Dieren"
  }
 },
 "da": {
  "ui": {
   "title": "Importassistent",
   "subtitle": "Importer dine dyr, kunder, produkter og lagerbeholdning fra en CSV- eller Excel-fil.",
   "columns": "{n} kolonner",
   "changeType": "Skift type",
   "expectedColumns": "Forventede kolonner:",
   "downloadTemplate": "Download skabelon",
   "dropzone": "Klik for at vælge en CSV- eller Excel-fil",
   "fileHint": ".csv, .xlsx — maks 5 Mo",
   "analyzing": "Analyserer filen…",
   "validRows": "{n} gyldig(e) række(r)",
   "errorRows": "{n} række(r) med fejl",
   "recognizedColumns": "Genkendte kolonner:",
   "previewNote": "Forhåndsvisning af de første {n} rækker.",
   "lineLabel": "Række",
   "importBtn": "Importer {n} række(r)",
   "cancel": "Annuller",
   "successMsg": "{n} element(er) importeret med succes 🎉",
   "skipped": "{n} række(r) sprunget over på grund af fejl.",
   "importAnother": "Importer en anden fil",
   "imported": "{n} element(er) importeret"
  },
  "res": {
   "customers": "Kunder",
   "products": "Produkter",
   "inventory-items": "Lager",
   "animal-batches": "Husdyr / Dyr"
  }
 },
 "hr": {
  "ui": {
   "title": "Pomoćnik za uvoz",
   "subtitle": "Uvezite svoje životinje, klijente, proizvode i zalihe iz CSV ili Excel datoteke.",
   "columns": "{n} stupaca",
   "changeType": "Promijeni vrstu",
   "expectedColumns": "Očekivani stupci:",
   "downloadTemplate": "Preuzmi predložak",
   "dropzone": "Kliknite za odabir CSV ili Excel datoteke",
   "fileHint": ".csv, .xlsx — maks 5 Mo",
   "analyzing": "Analiza datoteke…",
   "validRows": "{n} valjani redak/retka",
   "errorRows": "{n} redak/retka s greškom",
   "recognizedColumns": "Prepoznati stupci:",
   "previewNote": "Pregled prvih {n} redaka.",
   "lineLabel": "Redak",
   "importBtn": "Uvezi {n} redak/retka",
   "cancel": "Odustani",
   "successMsg": "{n} stavka/stavki uspješno uvezena 🎉",
   "skipped": "{n} redak/retka preskočeno zbog grešaka.",
   "importAnother": "Uvezi drugu datoteku",
   "imported": "{n} stavka/stavki uvezena"
  },
  "res": {
   "customers": "Klijenti",
   "products": "Proizvodi",
   "inventory-items": "Zalihe",
   "animal-batches": "Uzgoj / Životinje"
  }
 },
 "bg": {
  "ui": {
   "title": "Асистент за импорт",
   "subtitle": "Импортирайте вашите животни, клиенти, продукти и наличности от CSV или Excel файл.",
   "columns": "{n} колони",
   "changeType": "Промяна на типа",
   "expectedColumns": "Очаквани колони:",
   "downloadTemplate": "Изтегляне на шаблон",
   "dropzone": "Щракнете, за да изберете CSV или Excel файл",
   "fileHint": ".csv, .xlsx — макс 5 Mo",
   "analyzing": "Анализ на файла…",
   "validRows": "{n} валиден(и) ред(ове)",
   "errorRows": "{n} ред(ове) с грешка",
   "recognizedColumns": "Разпознати колони:",
   "previewNote": "Преглед на първите {n} реда.",
   "lineLabel": "Ред",
   "importBtn": "Импортиране на {n} ред(ове)",
   "cancel": "Отказ",
   "successMsg": "{n} елемент(а) са импортирани успешно 🎉",
   "skipped": "{n} ред(ове) са пропуснати поради грешки.",
   "importAnother": "Импортиране на друг файл",
   "imported": "{n} импортиран(и) елемент(а)"
  },
  "res": {
   "customers": "Клиенти",
   "products": "Продукти",
   "inventory-items": "Наличност",
   "animal-batches": "Животновъдство / Животни"
  }
 },
 "et": {
  "ui": {
   "title": "Impordiassistent",
   "subtitle": "Importige oma loomad, kliendid, tooted ja varud CSV- või Exceli failist.",
   "columns": "{n} veergu",
   "changeType": "Muuda tüüpi",
   "expectedColumns": "Oodatavad veerud:",
   "downloadTemplate": "Laadi mall alla",
   "dropzone": "Klõpsake CSV- või Exceli faili valimiseks",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Faili analüüsimine…",
   "validRows": "{n} kehtiv(at) rida",
   "errorRows": "{n} vigane(t) rida",
   "recognizedColumns": "Tuvastatud veerud:",
   "previewNote": "Esimese {n} rea eelvaade.",
   "lineLabel": "Rida",
   "importBtn": "Impordi {n} rida",
   "cancel": "Tühista",
   "successMsg": "{n} element(i) edukalt imporditud 🎉",
   "skipped": "{n} rida jäeti vigade tõttu vahele.",
   "importAnother": "Impordi teine fail",
   "imported": "{n} element(i) imporditud"
  },
  "res": {
   "customers": "Kliendid",
   "products": "Tooted",
   "inventory-items": "Varud",
   "animal-batches": "Loomakasvatus / Loomad"
  }
 },
 "el": {
  "ui": {
   "title": "Βοηθός εισαγωγής",
   "subtitle": "Εισάγετε τα ζώα, τους πελάτες, τα προϊόντα και τα αποθέματά σας από αρχείο CSV ή Excel.",
   "columns": "{n} στήλες",
   "changeType": "Αλλαγή τύπου",
   "expectedColumns": "Αναμενόμενες στήλες:",
   "downloadTemplate": "Λήψη προτύπου",
   "dropzone": "Κάντε κλικ για να επιλέξετε αρχείο CSV ή Excel",
   "fileHint": ".csv, .xlsx — μέγ. 5 Mo",
   "analyzing": "Ανάλυση αρχείου…",
   "validRows": "{n} έγκυρη(ες) γραμμή(ές)",
   "errorRows": "{n} γραμμή(ές) με σφάλμα",
   "recognizedColumns": "Αναγνωρισμένες στήλες:",
   "previewNote": "Προεπισκόπηση των {n} πρώτων γραμμών.",
   "lineLabel": "Γραμμή",
   "importBtn": "Εισαγωγή {n} γραμμή(ών)",
   "cancel": "Ακύρωση",
   "successMsg": "{n} στοιχείο(α) εισήχθη(αν) με επιτυχία 🎉",
   "skipped": "{n} γραμμή(ές) παραλείφθηκε(αν) λόγω σφαλμάτων.",
   "importAnother": "Εισαγωγή άλλου αρχείου",
   "imported": "{n} στοιχείο(α) εισήχθη(αν)"
  },
  "res": {
   "customers": "Πελάτες",
   "products": "Προϊόντα",
   "inventory-items": "Απόθεμα",
   "animal-batches": "Κτηνοτροφία / Ζώα"
  }
 },
 "fi": {
  "ui": {
   "title": "Tuontiavustaja",
   "subtitle": "Tuo eläimet, asiakkaat, tuotteet ja varastot CSV- tai Excel-tiedostosta.",
   "columns": "{n} saraketta",
   "changeType": "Vaihda tyyppiä",
   "expectedColumns": "Odotetut sarakkeet:",
   "downloadTemplate": "Lataa malli",
   "dropzone": "Napsauta valitaksesi CSV- tai Excel-tiedosto",
   "fileHint": ".csv, .xlsx — enintään 5 Mo",
   "analyzing": "Analysoidaan tiedostoa…",
   "validRows": "{n} kelvollinen rivi",
   "errorRows": "{n} virheellinen rivi",
   "recognizedColumns": "Tunnistetut sarakkeet:",
   "previewNote": "Esikatselu {n} ensimmäisestä rivistä.",
   "lineLabel": "Rivi",
   "importBtn": "Tuo {n} rivi(ä)",
   "cancel": "Peruuta",
   "successMsg": "{n} kohde(tta) tuotu onnistuneesti 🎉",
   "skipped": "{n} rivi(ä) ohitettu virheiden vuoksi.",
   "importAnother": "Tuo toinen tiedosto",
   "imported": "{n} kohde(tta) tuotu"
  },
  "res": {
   "customers": "Asiakkaat",
   "products": "Tuotteet",
   "inventory-items": "Varasto",
   "animal-batches": "Kasvatus / Eläimet"
  }
 },
 "hu": {
  "ui": {
   "title": "Import varázsló",
   "subtitle": "Importálja állatait, ügyfeleit, termékeit és készleteit CSV vagy Excel fájlból.",
   "columns": "{n} oszlop",
   "changeType": "Típus módosítása",
   "expectedColumns": "Várt oszlopok:",
   "downloadTemplate": "Sablon letöltése",
   "dropzone": "Kattintson CSV vagy Excel fájl kiválasztásához",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Fájl elemzése…",
   "validRows": "{n} érvényes sor",
   "errorRows": "{n} hibás sor",
   "recognizedColumns": "Felismert oszlopok:",
   "previewNote": "Az első {n} sor előnézete.",
   "lineLabel": "Sor",
   "importBtn": "{n} sor importálása",
   "cancel": "Mégse",
   "successMsg": "{n} elem sikeresen importálva 🎉",
   "skipped": "{n} sor kihagyva hibák miatt.",
   "importAnother": "Másik fájl importálása",
   "imported": "{n} elem importálva"
  },
  "res": {
   "customers": "Ügyfelek",
   "products": "Termékek",
   "inventory-items": "Készlet",
   "animal-batches": "Állattenyésztés / Állatok"
  }
 },
 "pl": {
  "ui": {
   "title": "Asystent importu",
   "subtitle": "Importuj zwierzęta, klientów, produkty i stany magazynowe z pliku CSV lub Excel.",
   "columns": "{n} kolumny(kolumn)",
   "changeType": "Zmień typ",
   "expectedColumns": "Oczekiwane kolumny:",
   "downloadTemplate": "Pobierz szablon",
   "dropzone": "Kliknij, aby wybrać plik CSV lub Excel",
   "fileHint": ".csv, .xlsx — maks. 5 Mo",
   "analyzing": "Analizowanie pliku…",
   "validRows": "{n} poprawny(ch) wiersz(y)",
   "errorRows": "{n} wiersz(y) z błędami",
   "recognizedColumns": "Rozpoznane kolumny:",
   "previewNote": "Podgląd pierwszych {n} wierszy.",
   "lineLabel": "Wiersz",
   "importBtn": "Importuj {n} wiersz(y)",
   "cancel": "Anuluj",
   "successMsg": "{n} element(ów) zaimportowanych pomyślnie 🎉",
   "skipped": "{n} wiersz(y) pominięty(ch) z powodu błędów.",
   "importAnother": "Importuj inny plik",
   "imported": "{n} element(ów) zaimportowanych"
  },
  "res": {
   "customers": "Klienci",
   "products": "Produkty",
   "inventory-items": "Magazyn",
   "animal-batches": "Hodowla / Zwierzęta"
  }
 },
 "lv": {
  "ui": {
   "title": "Importēšanas palīgs",
   "subtitle": "Importējiet savus dzīvniekus, klientus, produktus un krājumus no CSV vai Excel faila.",
   "columns": "{n} kolonnas",
   "changeType": "Mainīt veidu",
   "expectedColumns": "Paredzētās kolonnas:",
   "downloadTemplate": "Lejupielādēt veidni",
   "dropzone": "Noklikšķiniet, lai izvēlētos CSV vai Excel failu",
   "fileHint": ".csv, .xlsx — maks. 5 Mo",
   "analyzing": "Faila analīze…",
   "validRows": "{n} derīga(-as) rinda(-as)",
   "errorRows": "{n} rinda(-as) ar kļūdām",
   "recognizedColumns": "Atpazītās kolonnas:",
   "previewNote": "Pirmo {n} rindu priekšskatījums.",
   "lineLabel": "Rinda",
   "importBtn": "Importēt {n} rindu(-as)",
   "cancel": "Atcelt",
   "successMsg": "{n} elements(-i) veiksmīgi importēts(-i) 🎉",
   "skipped": "{n} rinda(-as) izlaista(-as) kļūdu dēļ.",
   "importAnother": "Importēt citu failu",
   "imported": "{n} elements(-i) importēts(-i)"
  },
  "res": {
   "customers": "Klienti",
   "products": "Produkti",
   "inventory-items": "Krājumi",
   "animal-batches": "Lopkopība / Dzīvnieki"
  }
 },
 "lt": {
  "ui": {
   "title": "Importavimo asistentas",
   "subtitle": "Importuokite savo gyvūnus, klientus, produktus ir atsargas iš CSV arba Excel failo.",
   "columns": "{n} stulpeliai",
   "changeType": "Keisti tipą",
   "expectedColumns": "Laukiami stulpeliai:",
   "downloadTemplate": "Atsisiųsti šabloną",
   "dropzone": "Spustelėkite, kad pasirinktumėte CSV arba Excel failą",
   "fileHint": ".csv, .xlsx — maks. 5 Mo",
   "analyzing": "Failo analizė…",
   "validRows": "{n} tinkama(-os) eilutė(-ės)",
   "errorRows": "{n} klaidos eilutė(-ės)",
   "recognizedColumns": "Atpažinti stulpeliai:",
   "previewNote": "Pirmųjų {n} eilučių peržiūra.",
   "lineLabel": "Eilutė",
   "importBtn": "Importuoti {n} eilutę(-es)",
   "cancel": "Atšaukti",
   "successMsg": "{n} elementas(-ai) sėkmingai importuotas(-i) 🎉",
   "skipped": "{n} eilutė(-ės) praleista(-os) dėl klaidų.",
   "importAnother": "Importuoti kitą failą",
   "imported": "{n} elementas(-ai) importuotas(-i)"
  },
  "res": {
   "customers": "Klientai",
   "products": "Produktai",
   "inventory-items": "Atsargos",
   "animal-batches": "Gyvulininkystė / Gyvūnai"
  }
 },
 "pt": {
  "ui": {
   "title": "Assistente de importação",
   "subtitle": "Importe seus animais, clientes, produtos e estoques a partir de um arquivo CSV ou Excel.",
   "columns": "{n} colunas",
   "changeType": "Alterar tipo",
   "expectedColumns": "Colunas esperadas :",
   "downloadTemplate": "Baixar o modelo",
   "dropzone": "Clique para escolher um arquivo CSV ou Excel",
   "fileHint": ".csv, .xlsx — máx 5 Mo",
   "analyzing": "Analisando o arquivo…",
   "validRows": "{n} linha(s) válida(s)",
   "errorRows": "{n} linha(s) com erro",
   "recognizedColumns": "Colunas reconhecidas :",
   "previewNote": "Pré-visualização das {n} primeiras linhas.",
   "lineLabel": "Linha",
   "importBtn": "Importar {n} linha(s)",
   "cancel": "Cancelar",
   "successMsg": "{n} elemento(s) importado(s) com sucesso 🎉",
   "skipped": "{n} linha(s) ignorada(s) por erros.",
   "importAnother": "Importar outro arquivo",
   "imported": "{n} elemento(s) importado(s)"
  },
  "res": {
   "customers": "Clientes",
   "products": "Produtos",
   "inventory-items": "Estoque",
   "animal-batches": "Criação / Animais"
  }
 },
 "sk": {
  "ui": {
   "title": "Sprievodca importom",
   "subtitle": "Importujte svoje zvieratá, zákazníkov, produkty a zásoby zo súboru CSV alebo Excel.",
   "columns": "{n} stĺpcov",
   "changeType": "Zmeniť typ",
   "expectedColumns": "Očakávané stĺpce:",
   "downloadTemplate": "Stiahnuť šablónu",
   "dropzone": "Kliknite pre výber súboru CSV alebo Excel",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Analýza súboru…",
   "validRows": "{n} platný(ch) riadok(kov)",
   "errorRows": "{n} riadok(kov) s chybou",
   "recognizedColumns": "Rozpoznané stĺpce:",
   "previewNote": "Náhľad prvých {n} riadkov.",
   "lineLabel": "Riadok",
   "importBtn": "Importovať {n} riadok(kov)",
   "cancel": "Zrušiť",
   "successMsg": "{n} položka(iek) úspešne importovaná(ých) 🎉",
   "skipped": "{n} riadok(kov) preskočených pre chyby.",
   "importAnother": "Importovať ďalší súbor",
   "imported": "{n} položka(iek) importovaná(ých)"
  },
  "res": {
   "customers": "Zákazníci",
   "products": "Produkty",
   "inventory-items": "Zásoby",
   "animal-batches": "Chov / Zvieratá"
  }
 },
 "ro": {
  "ui": {
   "title": "Asistent de import",
   "subtitle": "Importați animalele, clienții, produsele și stocurile dintr-un fișier CSV sau Excel.",
   "columns": "{n} coloane",
   "changeType": "Schimbați tipul",
   "expectedColumns": "Coloane așteptate :",
   "downloadTemplate": "Descărcați modelul",
   "dropzone": "Faceți clic pentru a alege un fișier CSV sau Excel",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Analizare fișier…",
   "validRows": "{n} linie(i) validă(e)",
   "errorRows": "{n} linie(i) cu erori",
   "recognizedColumns": "Coloane recunoscute :",
   "previewNote": "Previzualizarea primelor {n} linii.",
   "lineLabel": "Linie",
   "importBtn": "Importați {n} linie(i)",
   "cancel": "Anulați",
   "successMsg": "{n} element(e) importat(e) cu succes 🎉",
   "skipped": "{n} linie(i) ignorate din cauza erorilor.",
   "importAnother": "Importați un alt fișier",
   "imported": "{n} element(e) importat(e)"
  },
  "res": {
   "customers": "Clienți",
   "products": "Produse",
   "inventory-items": "Stoc",
   "animal-batches": "Creșterea animalelor / Animale"
  }
 },
 "sl": {
  "ui": {
   "title": "Čarovnik za uvoz",
   "subtitle": "Uvozite svoje živali, stranke, izdelke in zaloge iz datoteke CSV ali Excel.",
   "columns": "{n} stolpcev",
   "changeType": "Spremeni vrsto",
   "expectedColumns": "Pričakovani stolpci:",
   "downloadTemplate": "Prenesi predlogo",
   "dropzone": "Kliknite za izbiro datoteke CSV ali Excel",
   "fileHint": ".csv, .xlsx — največ 5 Mo",
   "analyzing": "Analiza datoteke…",
   "validRows": "{n} veljavna(-e/-ih) vrstica(-e/-ic)",
   "errorRows": "{n} vrstica(-e/-ic) z napako",
   "recognizedColumns": "Prepoznani stolpci:",
   "previewNote": "Predogled prvih {n} vrstic.",
   "lineLabel": "Vrstica",
   "importBtn": "Uvozi {n} vrstico(-e/-ic)",
   "cancel": "Prekliči",
   "successMsg": "{n} element(i) uspešno uvožen(i) 🎉",
   "skipped": "{n} vrstica(-e/-ic) preskočena(-e/-ih) zaradi napak.",
   "importAnother": "Uvozi drugo datoteko",
   "imported": "{n} element(i) uvožen(i)"
  },
  "res": {
   "customers": "Stranke",
   "products": "Izdelki",
   "inventory-items": "Zaloga",
   "animal-batches": "Reja / Živali"
  }
 },
 "cs": {
  "ui": {
   "title": "Průvodce importem",
   "subtitle": "Importujte svá zvířata, zákazníky, produkty a zásoby ze souboru CSV nebo Excel.",
   "columns": "{n} sloupců",
   "changeType": "Změnit typ",
   "expectedColumns": "Očekávané sloupce:",
   "downloadTemplate": "Stáhnout šablonu",
   "dropzone": "Klikněte pro výběr souboru CSV nebo Excel",
   "fileHint": ".csv, .xlsx — max 5 Mo",
   "analyzing": "Analýza souboru…",
   "validRows": "{n} platný(ch) řádek(řádků)",
   "errorRows": "{n} řádek(řádků) s chybou",
   "recognizedColumns": "Rozpoznané sloupce:",
   "previewNote": "Náhled prvních {n} řádků.",
   "lineLabel": "Řádek",
   "importBtn": "Importovat {n} řádek(řádků)",
   "cancel": "Zrušit",
   "successMsg": "{n} položka(položek) úspěšně importována(importováno) 🎉",
   "skipped": "{n} řádek(řádků) přeskočeno z důvodu chyb.",
   "importAnother": "Importovat další soubor",
   "imported": "{n} položka(položek) importována(importováno)"
  },
  "res": {
   "customers": "Zákazníci",
   "products": "Produkty",
   "inventory-items": "Zásoby",
   "animal-batches": "Chov / Zvířata"
  }
 }
};
